export default "__VITE_ASSET__8e346f32__"